import type { OnboardingStatusAPIType } from '../vendor-portal/onboarding/types';

export type VendorDataType = {
  vendor_id: string;
  first_name: string;
  last_name: string;
  email: string;
  company_name: string;
  link: string;
  address: string;
  status: {
    slug: string;
    title: string;
  };
  phone_number: string;
  gl_insurance_expiry: string;
  is_active: boolean;
  company_address: {
    street_address?: string | null;
    apt_suite_unit?: string;
    city?: string | null;
    state_code?: string | null;
    zip_code?: string | null;
  };
  markets?: Array<{
    id: string;
    name: string;
  }>;
  onboarding: {
    vendor_onboarding_id?: string;
    status?: OnboardingStatusAPIType;
  };
  // Vendors sourced from a property management system (Yardi/AppFolio). The PMS
  // owns their contact/address data, so anything it left blank cannot be fixed
  // from Foresight and blocks the onboarding invite.
  is_synced: boolean;
  missing_onboarding_fields: string[];
};

type VendorMetaType = {
  current_page: number;
  from: number;
  last: string;
  next: string;
  per_page: number;
  prev: string;
  to: number;
  total: number;
};

export type VendorPusherDataType = {
  vendor_id: string;
  onboarding: {
    onboarding_id: string;
    status: OnboardingStatusAPIType;
  };
};

export type InitialStateType = {
  isLoading: boolean;
  isDetailsLoading: boolean;
  data: {
    data: Array<string>;
    meta: VendorMetaType;
  };
  groupedData: {
    [key: string]: Array<string>;
  };
  source: {
    [key: string]: VendorDataType;
  };
};

export const vendorInitialState: InitialStateType = {
  isLoading: false,
  isDetailsLoading: false,
  data: {
    data: [],
    meta: {
      next: '',
      per_page: 0,
      prev: '',
      total: 0,
      current_page: 0,
      from: 0,
      to: 0,
      last: '',
    },
  },
  groupedData: {},
  source: {},
};
